angular.module('loading', []);

angular.module('loading')

.factory('httpListener', ['$q', function($q) {
  var httpListener = {
    callback: function() {},
    request: function(config) {
      httpListener.callback(true);
      return config;
    },
    response: function(response) {
      httpListener.callback(false);
      return response;
    },
    responseError: function(err) {
      httpListener.callback(false);
      return $q.reject(err);
    },
    setCallback: function(fn) {
      httpListener.callback = fn;
    }
  };
  return httpListener;
}])

.config(['$httpProvider', function($httpProvider) {
  $httpProvider.interceptors.push('httpListener');
}])

.component('loading', {
  template: require('./loading.html'),
  controller: ['httpListener', function(httpListener) {
    var i = 0;
    var $ctrl = this;
    $ctrl.isLoading = false;
    httpListener.setCallback(function(isLoading) {
      // accumulates the amount of ongoing requests
      i += isLoading ? 1 : -1;
      // turn of the isLoading only when the amount of ongoing request is 0
      $ctrl.isLoading = !!i;
    });
  }]
});



// WEBPACK FOOTER //
// ./src/lib/loading/loading.js